/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
import type { AskGwiResearchDto } from '@inference.engine/api-client/web';

export type GwiResearchCategory = NonNullable<AskGwiResearchDto['category']>;

export const GWI_RESEARCH_QUERY_KEYS = {
  all: (personaId: string) => ['gwi-research', personaId] as const,
  history: (personaId: string, category?: GwiResearchCategory) =>
    [...GWI_RESEARCH_QUERY_KEYS.all(personaId), 'history', category ?? null] as const,
} as const;
